import { render } from "./PurchaseDataRegisterView.vue?vue&type=template&id=2540ec1e&scoped=true"
import script from "./PurchaseDataRegisterView.vue?vue&type=script&lang=js"
export * from "./PurchaseDataRegisterView.vue?vue&type=script&lang=js"

import "./PurchaseDataRegisterView.vue?vue&type=style&index=0&id=2540ec1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2540ec1e"]])

export default __exports__